(function(){
  // scroll gauge
  var fill = document.getElementById('scrollFill');
  function onScroll(){
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? (window.scrollY / h) * 100 : 0;
    fill.style.width = p.toFixed(2) + '%';
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  // mobile nav
  var t = document.getElementById('navToggle'), l = document.getElementById('navLinks');
  t.addEventListener('click', function(){
    var open = l.classList.toggle('open');
    t.setAttribute('aria-expanded', open);
    t.textContent = open ? 'Close' : 'Menu';
  });
  l.addEventListener('click', function(e){
    if(e.target.tagName === 'A'){ l.classList.remove('open'); t.textContent='Menu'; t.setAttribute('aria-expanded','false'); }
  });

  // reveal on scroll
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.rise');
  if(reduce || !('IntersectionObserver' in window)){
    items.forEach(function(el){ el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    items.forEach(function(el, i){ el.style.transitionDelay = (i % 3) * 70 + 'ms'; io.observe(el); });
  }

  // hero video: only load/play if a source is present and motion is allowed
  var v = document.getElementById('heroVideo');
  if(v){
    var hasSource = v.querySelector('source') || v.getAttribute('src');
    if(hasSource && !reduce){ v.preload = 'auto'; v.load(); var p = v.play(); if(p && p.catch){ p.catch(function(){}); } }
    else { v.removeAttribute('autoplay'); }
  }
})();
